export default __webpack_public_path__ + "static/media/6.85e89d12.svg";